<kendo-listview [data]="systemUpdates" containerClass="k-d-flex k-flex-col k-flex-nowrap">
  <ng-template kendoListViewItemTemplate let-dataItem="dataItem" let-isFirst="isFirst">
    <div class="system-update" role="button" tabindex="0" (click)="onClick(dataItem)"
      (keydown.enter)="onClick(dataItem)" (keydown.space)="onClick(dataItem)" [class.border-top]="borderTop">

      <div class="system-update-details">
        <div>
          <span *ngIf="dataItem.read">
            <kendo-icon name="success" size="large"></kendo-icon>
          </span>
          <span *ngIf="!dataItem.read">
            <kendo-icon name="eye" size="large"></kendo-icon>
          </span>
          <span>{{ dataItem.message }}</span>
        </div>
      </div>
    </div>
  </ng-template>
</kendo-listview>